import { createSelector } from 'reselect';
import { RootState } from '../root-reducer';

const selectAffiliateState = (state: RootState) => state.affiliate;

export const selectAffiliates = createSelector([selectAffiliateState], affiliate => affiliate.affiliates);

export const selectAffiliatePagination = createSelector([selectAffiliateState], affiliate => ({
    totalCount: affiliate.totalCount,
    pageSize: affiliate.pageSize,
    currentPage: affiliate.currentPage,
    totalPages: affiliate.totalPages,
}));

export const selectAffiliateLoading = createSelector([selectAffiliateState], affiliate => affiliate.loading);

export const selectAffiliateCreateLoading = createSelector(
    [selectAffiliateState],
    affiliate => affiliate.createLoading,
);

export const selectAffiliateDeleteLoading = createSelector(
    [selectAffiliateState],
    affiliate => affiliate.deleteLoading,
);

export const selectAffiliateError = createSelector([selectAffiliateState], affiliate => affiliate.error);
